import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';

const PATH_TEMPLATE = '/creators/{creatorId}/custom-terms-dynamic-variables';
type THIS_API = ApiDefinition[typeof PATH_TEMPLATE]['PUT'];
type Input = THIS_API['params'] & THIS_API['body'];
type Output = THIS_API['response'];

const findOrCreateTypedCustomTermsDynamicVariable = async ({
  connectTemplateId,
  creatorId,
  type,
  variableName,
}: Input): Promise<Output> => {
  const path = buildPath<THIS_API>(PATH_TEMPLATE, { creatorId });
  const data = await noodleApiClient.put(path, { connectTemplateId, type, variableName });
  return data.data;
};

export default findOrCreateTypedCustomTermsDynamicVariable;
